import React from 'react';
import FontAwesome from 'react-fontawesome';
import Router, { RouteComponentProps } from 'react-router-dom';

import AccessoriesItem from './AccessoriesItem';

import { BREAK_POINT } from 'constants/responsive';
import Product from 'types/shopify/Product';

import { Helmet } from 'react-helmet';

import './Accessories.sass';

interface IAccessoriesMatchParams {
    type: string;
}

interface OwnProps extends RouteComponentProps<IAccessoriesMatchParams> {
    match: Router.match<IAccessoriesMatchParams>;
}

export interface StateProps {
    // Indicates whether the shopify api calls have completed
    isLoading: boolean;
    products: Product[];
    accessoriesMenuDictionary: any;
}

type CombinedProps = OwnProps & StateProps;

const filterProductsBasedOnType = (product: any, params: any, dict: any) => {
    if (params.type) {
        const typeInfo  = dict[params.type];

        if (typeInfo && typeInfo.handles.includes(product.handle)) {
            return true;
        }
        return false;
    }
    return true;
};

const Accessories: React.StatelessComponent<CombinedProps> = (props) => {

    const {
        isLoading,
        match,
        products
    } = props;

    if (isLoading) {
        return <FontAwesome className="loading-spinner" name="spinner" size="3x" spin />;
    }

    /**
     * Temp function 11-20-2018
     * the product call is pulling instruments
     * we need to create a new api call to separate the two
     * we don't have time so this is the temp fix
     */
    const filterOutInstruments = (items: Product[]) => {
        return items.filter((p: Product) => p.product_type !== 'Instrument');
    };

    const instruments = filterOutInstruments(products).filter((p: any) => filterProductsBasedOnType(p, props.match.params, props.accessoriesMenuDictionary)).map((p: Product) => {
        return (
            <div key={p.id} className={`col-${window.innerWidth < BREAK_POINT ? '6' : '3'}`}>
                <AccessoriesItem item={p} match={match} />
            </div>
        );
    }).reduce<JSX.Element[][]>((prev: JSX.Element[][], cur: JSX.Element, index: number) => {
        if (index % (window.innerWidth < BREAK_POINT ? 2 : 4) === 0) prev.push(Array());
        prev[prev.length - 1].push(cur);
        return prev;
    },                         []).map((subElms: JSX.Element[]) => {
        return <div className="row Accessories-row" key={subElms.map(s => s.key).join()}>{subElms}</div>;
    });

    // If we don't have any instruments, it means that the user has navigated to a URL that is an invalid
    // type of accessory, so instead of displaying a potentially confusing error message
    // we should just navigate to all accessories
    if (instruments.length < 1) {
        props.history.push('/accessories');
    }

    return (
        <div className="Accessories-container" >
            <Helmet>
                <meta name="title" content="Vintage Guitars Accessories Shop | Gruhn Guitars in Nashville, Tennessee" />
                <meta name="description" content="Shop Gruhn Guitars accessories including books, hats, and t-shirts from our world-famous music store in Nashville, Tennessee, now celebrating 50 years." />
                <title>Vintage Guitars Accessories Shop | Gruhn Guitars in Nashville, Tennessee</title>
            </Helmet>
            <div className="col-10 offset-1 Accessories-title">GRUHN GUITARS ACCESSORIES SHOP</div>
            <div className="col-10 offset-1 Accessories">
                {instruments}
            </div>
        </div>
    );
};

export default Accessories;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/Accessories.tsx